import { render, staticRenderFns } from "./Full.vue?vue&type=template&id=70adbb23&scoped=true"
import script from "./Full.vue?vue&type=script&setup=true&lang=js"
export * from "./Full.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Full.vue?vue&type=style&index=0&id=70adbb23&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70adbb23",
  null
  
)

export default component.exports